import { render, staticRenderFns } from "./VueContextMenu.vue?vue&type=template&id=480f76d6&scoped=true&"
import script from "./VueContextMenu.vue?vue&type=script&lang=js&"
export * from "./VueContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f76d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VTooltip})


/* vuetify-loader */
import installIcons from "!../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiCancel } from '@mdi/js';
import { mdiCheck } from '@mdi/js';
import { mdiClipboardCheckOutline } from '@mdi/js';
import { mdiDeleteOutline } from '@mdi/js';
import { mdiDotsHorizontal } from '@mdi/js';
import { mdiDownload } from '@mdi/js';
import { mdiExport } from '@mdi/js';
import { mdiEye } from '@mdi/js';
import { mdiEyeOutline } from '@mdi/js';
import { mdiForumOutline } from '@mdi/js';
import { mdiInformationOutline } from '@mdi/js';
import { mdiPencilOutline } from '@mdi/js';
import { mdiRefresh } from '@mdi/js';
import { mdiShieldCheck } from '@mdi/js';
import { mdiUpdate } from '@mdi/js';
import { mdiViewGridOutline } from '@mdi/js';
import { mdiVolumeHigh } from '@mdi/js';
installIcons(component, {mdiCancel,mdiCheck,mdiClipboardCheckOutline,mdiDeleteOutline,mdiDotsHorizontal,mdiDownload,mdiExport,mdiEye,mdiEyeOutline,mdiForumOutline,mdiInformationOutline,mdiPencilOutline,mdiRefresh,mdiShieldCheck,mdiUpdate,mdiViewGridOutline,mdiVolumeHigh})
